import React from 'react';

export function Morning() {
  return <div />;
}

export function Afternoon() {
  return <div />;
}

export function Night() {
  return <div />;
}

export function NoTime() {
  return null;
}

export function Monday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Monday</p>
    </>
  );
}

export function Tuesday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Tuesday</p>
    </>
  );
}

export function Wednesday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Wednesday</p>
    </>
  );
}

export function Thursday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Thursday</p>
    </>
  );
}

export function Friday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Friday</p>
    </>
  );
}

export function Saturday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Saturday</p>
    </>
  );
}

export function Sunday() {
  return (
    <>
      {' '}
      <p className="text-dark-night">&nbsp; Sunday</p>
    </>
  );
}

export function NoDay() {
  return <p className="text-dark-night">incoming</p>;
}
